import React, {FC} from "react";
import {MonitorPO} from "@/model/product";
import {GridActionsCellItem, GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import isEmpty from "lodash/isEmpty";

export interface MonitorTableProps {
    data?: MonitorPO[]
}

export const MonitorTable: FC<MonitorTableProps> = ({data}) => {

    const columns: GridColDef<MonitorPO>[] = [
        {
            field: "feeType",
            headerName: "费用名称",
            headerAlign: "left",
            align: "left",
            flex: 0.6,
        },
        {
            field: "deadline",
            headerName: "最后期限",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
            flex: 0.6,
            renderCell: ({row}) => {
                if (row.feeId < 3) {
                    if (isEmpty(row.deadline)) {
                        return '-'
                    }
                }
            }
        },
        {
            field: "paymentStatus",
            headerName: "缴费状态",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            renderCell: ({row: {paymentStatus, feeId, feeType, amount}}) => {
                if (feeId < 3) {
                    if (isEmpty(amount)) {
                        return `未产生${feeType}`
                    }
                }
                if (paymentStatus === -1) {
                    return <Chip size={'small'} variant={'filled'} color={'error'} label={'未缴费'}/>
                } else {
                    return <Chip size={'small'} variant={'filled'} color={'success'} label={'已缴费'}/>
                }
            },
        }, {
            field: "amount",
            headerName: "缴费金额",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
            valueFormatter: (value) => `￥${value || "-"}`,
            renderCell: ({row}) => {
                if (row.feeId < 3) {
                    if (isEmpty(row.amount)) {
                        return '-'
                    }
                }
            }
        }, {
            field: "actions",
            type: "actions",
            headerName: "操作",
            getActions: ({row}) => [<GridActionsCellItem
                label="查看"
                icon={<Checkbox checked={row.paymentStatus == 1}/>}
                color={'default'}
                onClick={() => {
                }}
            />]
        }]

    return <ProTable<MonitorPO> showToolbar={false} checkboxSelection={false} autoHeight={false} columnHeaderHeight={40}
                                pageSize={5} rowId={'feeId'}
                                columns={columns} source={{
        dataSource: {
            getRows: async () => {
                return {rows: data || [], rowCount: data?.length}
            }
        }, rowCount: data?.length || 0
    }}/>
}